import { toast } from 'sonner';

export const apiSuccess = (message: string) => {
  // toast.dismiss();
  toast.success(message);
};

export const apiError = (message: string) => {
  // toast.dismiss();
  toast.error(message);
};

export const apiInfo = (message: string) => {
  // toast.dismiss();
  toast(message);
};
